module.exports = __webpack_public_path__ + "static/img/news5_1.5ea1b54.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/news5_1.jpg
// module id = BXDS
// module chunks = 1